import './css/VideoSection.css'
import NavBar from './homeComponents/NavBar';
import Footer from './homeComponents/Footer';
import QuestionService from './questionComponents/QuestionService';
import { useLayoutEffect } from 'react';

export default function Questions() {
  useLayoutEffect(() => {
    window.scrollTo(0, 0)
});
  return (
    <div>
        <NavBar />
        <QuestionService />
        <Footer />
    </div>
  );
}